export const counter = (
    finalValue: number, 
    seconds: number, 
    callback: (value: number, finish: boolean) => void,
    integerOnly: boolean = false // nueva opción
) => {
    const startTime = (new Date()).getTime();
    const milliseconds = seconds*1000;
  
    (function update() {
        var currentTime = (new Date()).getTime();
        var value = finalValue * (currentTime - startTime) / milliseconds;

        if (value >= finalValue) {
            value = finalValue;
        }
        else {
            setTimeout(update, 0);
        }

        const outputValue = integerOnly ? Math.floor(value) : value;

        callback(outputValue, value === finalValue);

        return () => {
            value = finalValue;
        };
    })();
};
